function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { Link } from "@labs/schema";
import React, { Fragment } from "react";
import { useIntl } from "../../../utils/intl";
import ContactBlock from "../ContactBlock";
export function Footer(props) {
    var _props_currentPage;
    var intl = useIntl();
    var locale = intl.locale;
    var legalNavigation = locale === "de" ? props.nav_de : props.nav_en;
    var _ref = locale === "de" ? props.contact_de : props.contact_en, email = _ref.email, address = _ref.address, linkedin = _ref.linkedin, instagram = _ref.instagram, phone = _ref.phone, mastodon = _ref.mastodon;
    var newDate = new Date();
    var year = newDate.getFullYear();
    var footerText = intl.formatMessage({
        defaultMessage: "\xa9 Amazee Labs {year}. All rights reserved.",
        id: "BhjM1p"
    }, {
        year: year
    });
    return /*#__PURE__*/ React.createElement("footer", {
        id: "footer",
        className: "mob:pb-6 relative z-10 pb-5"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "sr-only"
    }, intl.formatMessage({
        defaultMessage: "Footer",
        id: "Vge+RX"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "container-page"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content"
    }, ((_props_currentPage = props.currentPage) === null || _props_currentPage === void 0 ? void 0 : _props_currentPage.contact) ? /*#__PURE__*/ React.createElement(ContactBlock, _extends({}, props.currentPage.contact, {
        intro: props.currentPage.contact_intro
    })) : null, /*#__PURE__*/ React.createElement("div", {
        className: "text-center max-w-2xl mx-auto"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "mailto:".concat(email),
        className: "text-purple focus block text-base font-normal sm:text-lg md:text-xl font-lexendGiga mb-2 md:mb-8 hover:text-turquoise-600"
    }, email), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col md:flex-row mb-6 text-sm"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "md:flex-1 text-center leading-[3] mt-3"
    }, address.map(function(line, index) {
        return index === 0 ? line : /*#__PURE__*/ React.createElement(Fragment, {
            key: index
        }, /*#__PURE__*/ React.createElement("br", null), line);
    })), /*#__PURE__*/ React.createElement(Link, {
        href: intl.locale === "de" ? "/de" : "/",
        className: "text-center order-last md:order-none"
    }, /*#__PURE__*/ React.createElement("img", {
        src: "/images/icon.png",
        alt: "Amazee Labs logo",
        width: 642,
        height: 642,
        className: "mx-auto max-w-full w-28 md:w-32 h-auto shrink-0"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex-1 text-center mt-2 md:mt-4 mb-6 md:mb-0"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "tel:".concat(phone),
        className: "block text-purple hover:underline"
    }, phone), /*#__PURE__*/ React.createElement("a", {
        href: linkedin,
        target: "_blank",
        className: "block text-purple mt-2 hover:underline focus",
        rel: "noreferrer"
    }, intl.formatMessage({
        defaultMessage: "LinkedIn",
        id: "Rb/hb9"
    })), /*#__PURE__*/ React.createElement("a", {
        href: instagram,
        target: "_blank",
        className: "block text-purple mt-2 hover:underline focus",
        rel: "noreferrer"
    }, intl.formatMessage({
        defaultMessage: "Instagram",
        id: "39PtLD"
    })), /*#__PURE__*/ React.createElement("a", {
        href: mastodon,
        target: "_blank",
        className: "block text-purple mt-2 hover:underline focus",
        rel: "noreferrer"
    }, intl.formatMessage({
        defaultMessage: "Mastodon",
        id: "aRFkJ/"
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: "md:flex md:justify-between text-xs"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-center md:text-left md:inline-block mb-3.5 md:mb-0"
    }, footerText), /*#__PURE__*/ React.createElement("nav", {
        className: "md:inline-block"
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "text-center md:text-left md:flex md:flex-wrap"
    }, legalNavigation && legalNavigation.map(function(param, index) {
        var label = param.label, link = param.link;
        return /*#__PURE__*/ React.createElement("li", {
            key: index,
            className: "md:inline-block"
        }, /*#__PURE__*/ React.createElement(Link, {
            href: link,
            className: "hover:text-purple focus hover:underline text-turquoise-500 md:text-black transition-all ml-2"
        }, label));
    })))))));
}
